module.exports = __webpack_public_path__ + "img/HZMB_FIRST_PERSON.546c9e21.png";